import { BottomSheet, BottomSheetIllustrationContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { logEvent } from "@src/appV2/lib/analytics";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics/events";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { useHistory } from "react-router-dom";

interface PendingLicenseAlertBottomSheetProps {
  modalState: UseModalState;
}

export function PendingLicenseAlertBottomSheet(props: PendingLicenseAlertBottomSheetProps) {
  const { modalState } = props;
  const history = useHistory();

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            onClick={() => {
              logEvent(
                APP_V2_USER_EVENTS.PENDING_LICENSE_ALERT_BOTTOM_SHEET_DISMISS_BUTTON_CLICKED
              );
              modalState.closeModal();
            }}
          >
            Dismiss
          </Button>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              logEvent(
                APP_V2_USER_EVENTS.PENDING_LICENSE_ALERT_BOTTOM_SHEET_SHOW_LICENSES_BUTTON_CLICKED
              );
              modalState.closeModal();
              history.push(DeprecatedGlobalAppV1Paths.LICENSE_MANAGER);
            }}
          >
            View Licenses
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="info"
        title="License pending"
        description="We're working on verifying your licenses. We'll send you a notification when we've finished!"
      />
    </BottomSheet>
  );
}
